import React from 'react';
import { FaEye, FaBullseye } from 'react-icons/fa';

const VisionMission = () => {
  return (
    <section className="py-20 bg-white" data-testid="vision-mission-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Vision & Mission</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Committed to building a competent workforce and transforming futures
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Vision Card */}
          <div
            className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-blue-600 to-blue-700 p-8 text-white shadow-xl hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300"
            data-testid="vision-card"
          >
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-32 h-32 bg-white/10 rounded-full"></div>
            <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-24 h-24 bg-white/10 rounded-full"></div>
            
            <div className="relative z-10">
              <div className="inline-flex p-4 bg-white/20 rounded-xl mb-6">
                <FaEye className="text-4xl" />
              </div>
              <h3 className="text-3xl font-bold mb-4">Vision</h3>
              <p className="text-lg text-blue-100 leading-relaxed">
                Our vision is to build <span className="font-bold text-white">10,000 competent pool of resources</span> on various technologies and domains in the next 5 years, creating a skilled workforce ready for the corporate world.
              </p>
            </div>
          </div>

          {/* Mission Card */}
          <div
            className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 p-8 text-white shadow-xl hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300"
            data-testid="mission-card"
          >
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-32 h-32 bg-white/10 rounded-full"></div>
            <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-24 h-24 bg-white/10 rounded-full"></div>
            
            <div className="relative z-10">
              <div className="inline-flex p-4 bg-white/20 rounded-xl mb-6">
                <FaBullseye className="text-4xl" />
              </div>
              <h3 className="text-3xl font-bold mb-4">Mission</h3>
              <p className="text-lg text-orange-100 leading-relaxed">
                Our mission is to provide <span className="font-bold text-white">high standards workforce solutions</span> for the corporate, quality training and mentoring for the trainees, bridging the gap between education and employment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;